export default "https://cdn-static.gokick.com/assets/9d5d62c9c10b295872f7f6ffd14ff177054c61a9/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";